import type { JSX } from "solid-js";

export type FilterType = "all" | "product";

export interface SearchResult {
  type: "product";
  id: string;
  text: string | null;
  color: string | null;
  icon: string | null;
}

export interface QuickAction {
  id: string;
  label: string;
  shortcut?: string;
  icon: () => JSX.Element;
  action: () => void;
}

export const FILTER_TYPES: readonly FilterType[] = ["all", "product"];
